import { render, staticRenderFns } from "./LayoutPrivate.vue?vue&type=template&id=797c9277&scoped=true&lang=html&"
import script from "./LayoutPrivate.vue?vue&type=script&lang=js&"
export * from "./LayoutPrivate.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPrivate.vue?vue&type=style&index=0&id=797c9277&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c9277",
  null
  
)

export default component.exports